import React from 'react';
import type { ReactElement } from 'react';
import 'twin.macro';
import { Link } from 'gatsby';

interface IconCardLinkProps {
  to: string;
  title: string;
  icons: ReactElement;
}

const IconCardLink: React.FC<IconCardLinkProps> = ({ to, title, icons, children }) => (
  <Link to={to} tw="block relative rounded-lg overflow-hidden shadow-sm text-white hover:(shadow-lg)">
    <div tw="relative flex flex-col items-start space-y-4 px-4 pt-64 pb-4 z-40">
      <div tw="flex justify-start space-x-2">{icons}</div>
      <p tw="text-3xl font-bold text-white">{title}</p>
    </div>
    <div tw="absolute inset-0 z-30">{children}</div>
  </Link>
);

export default IconCardLink;
